var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { keyframes } from "styled-components";
export var shimmerKeyframe = function (color) {
    if (color === void 0) { color = "rgba(0,0,0,0)"; }
    return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        box-shadow: ", "66 8px 16px 80px;\n    }\n    50% {\n        box-shadow: ", "29 8px 16px 80px;\n    }\n    100% {\n        box-shadow: ", "66 8px 16px 80px;\n    }\n"], ["\n    0% {\n        box-shadow: ", "66 8px 16px 80px;\n    }\n    50% {\n        box-shadow: ", "29 8px 16px 80px;\n    }\n    100% {\n        box-shadow: ", "66 8px 16px 80px;\n    }\n"])), color, color, color);
};
var templateObject_1;
//# sourceMappingURL=keyframes.js.map